/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorSeverityModel } from '../../models/patient-behavior-severity-model';

export interface GetPatientBehaviorSeverities$Params {
  onlyActive?: boolean;
}

export function GetPatientBehaviorSeverities(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorSeverities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorSeverityModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorSeverities.PATH, 'get');
  if (params) {
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorSeverityModel>>;
    })
  );
}

GetPatientBehaviorSeverities.PATH = '/api/Staff/GetPatientBehaviorSeverities';
